<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Jugada" />

    <CreatePlay />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreatePlay from "@/components/Pages/Admin/Plays/view.vue";

export default defineComponent({
  name: "CreatePlayPage",
  components: {
    PageTitle,
    CreatePlay,
  },
});
</script>
